import { api, getApiError } from './api';
import type { Payslip } from '../types';

type ApiRecord = Record<string, unknown>;

function mapPayslip(data: ApiRecord): Payslip {
  return {
    id: Number(data.id),
    payrollRunId: Number(data.payroll_run_id),
    periodName: String(data.period_name ?? ''),
    periodStart: String(data.period_start ?? ''),
    periodEnd: String(data.period_end ?? ''),
    status: String(data.status ?? 'confirmed') as Payslip['status'],
    basicSalary: Number(data.basic_salary ?? 0),
    overtimeAmount: Number(data.overtime_amount ?? 0),
    allowances: Number(data.allowances ?? 0),
    grossSalary: Number(data.gross_salary ?? 0),
    deductions: Number(data.deductions ?? 0),
    advancesDeducted: Number(data.advances_deducted ?? 0),
    totalDeductions: Number(data.total_deductions ?? 0),
    netSalary: Number(data.net_salary ?? 0),
    isProrated: Boolean(data.is_prorated),
    createdAt: String(data.created_at ?? ''),
  };
}

export const payslipService = {
  async getPayslips(): Promise<Payslip[]> {
    try {
      const { data } = await api.get<{ data: ApiRecord[] }>('/me/payslips');
      return (data.data ?? []).map(mapPayslip);
    } catch (err) {
      throw new Error(getApiError(err));
    }
  },

  async downloadPayslip(itemId: number, filename: string): Promise<void> {
    try {
      const { data } = await api.get(`/me/payslips/${itemId}/download`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([data as BlobPart]));
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      throw new Error(getApiError(err));
    }
  },
};
